// @flow
import React from "react";
import MenuList from "@material-ui/core/MenuList";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import { List, Map } from "immutable";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

const styles = (theme) => ({
  selected: {
    background: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
  root: {
    maxWidth: 200,
  },
});

type Props = {
  classes: Object,
  subTopics: List<Map<string, any>>,
  breadcrumbs: List<Map<string, string>>,
  redirect: (string) => void,
  title: ?string,
  url: string,
};

const HelpMenu = (props: Props) => {
  const { subTopics, breadcrumbs, redirect, classes, title, url } = props;
  const parentKey =
    breadcrumbs.size === 1
      ? ""
      : `/${breadcrumbs.getIn([breadcrumbs.size - 2, "key"], "")}`;
  return (
    <MenuList component="nav">
      <MenuItem component="div" disabled>
        <Typography variant="button">
          {title ? title : "ICPC Help Center"}
        </Typography>
      </MenuItem>
      {subTopics.map((subTopic) => {
        return (
          <MenuItem
            key={subTopic.get("key")}
            classes={{ selected: classes.selected }}
            selected={subTopic.get("active")}
            onClick={() => redirect(`${url}/${subTopic.get("key")}`)}
          >
            <ListItemText primary={subTopic.get("title")} />
            {!subTopic.get("leaf") && (
              <ListItemSecondaryAction>
                <ChevronRightIcon />
              </ListItemSecondaryAction>
            )}
          </MenuItem>
        );
      })}
      {breadcrumbs.size > 0 && (
        <MenuItem onClick={() => redirect(`${url}${parentKey}`)}>
          <ListItemIcon>
            <ChevronLeftIcon />
          </ListItemIcon>
          <ListItemText primary="Back" />
        </MenuItem>
      )}
    </MenuList>
  );
};

export default withStyles(styles)(HelpMenu);
